import { CanDeactivateFn } from '@angular/router';
import { EditUserPage } from './edit-user-page';

export const editUserUnsavedGuard: CanDeactivateFn<EditUserPage> = (component) =>
  component.confirmLeave();
